var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAttachment = function SvgAttachment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.121 4.818 4.879 9.061a.75.75 0 1 0 1.06 1.06l4.243-4.242A2.25 2.25 0 1 0 7 2.697L2.757 6.94a3.75 3.75 0 1 0 5.303 5.302L12.303 8l1.06 1.06-4.242 4.244a5.252 5.252 0 0 1-7.425-7.425l4.243-4.242a3.75 3.75 0 0 1 5.303 5.302L7 11.183A2.25 2.25 0 1 1 3.818 8L8.06 3.758z"
  })));
};
export default SvgAttachment;